/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'signal': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M1 3.556A2.556 2.556 0 0 1 3.556 1 43.445 43.445 0 0 1 47 44.444a2.556 2.556 0 0 1-5.111 0A38.333 38.333 0 0 0 3.556 6.111 2.556 2.556 0 0 1 1 3.556z"/><path pid="1" d="M1 21.444a2.556 2.556 0 0 1 2.556-2.555A25.556 25.556 0 0 1 29.11 44.444a2.556 2.556 0 1 1-5.111 0A20.444 20.444 0 0 0 3.556 24 2.556 2.556 0 0 1 1 21.444zM6.111 36.778a5.111 5.111 0 1 0 0 10.222 5.111 5.111 0 0 0 0-10.222z"/>'
  }
})
